(function () {
  const isSafariBrowser = () => {
    if (typeof navigator === "undefined") return false;
    const userAgent = navigator.userAgent;
    return /Safari/i.test(userAgent) && !/Chrome|Chromium|CriOS|FxiOS|Edg/i.test(userAgent);
  };

  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("media-banner-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const text = section.querySelector(".media-banner__heading");

    if (!text) return;

    ScrollTrigger.create({
      trigger: text,
      start: "50% 95%",
      end: "bottom top",
      onEnter: () => text.classList.add("animated"),
    });
  };

  const initVideoControls = (section) => {
    if (!section || !section.classList.contains("media-banner-section")) return;

    const videoWrapper = section.querySelector("[data-media-banner-video]");
    if (!videoWrapper) return;

    const video = videoWrapper.querySelector("video");
    const playButton = videoWrapper.querySelector(
      "[data-media-banner-video-play]"
    );
    const pauseButton = videoWrapper.querySelector(
      "[data-media-banner-video-pause]"
    );
    const mediaSurface = section.querySelector(".media-banner__media");
    const contentSurface = section.querySelector(".media-banner__content--video");

    if (!video || !playButton) return;

    const shouldPreloadForSafari = () => isSafariBrowser() && video.readyState < 2;

    const showPlay = () => {
      playButton.classList.remove("is-hidden");
      if (pauseButton) {
        pauseButton.classList.add("is-hidden");
      }
    };

    const showPause = () => {
      playButton.classList.add("is-hidden");
      if (pauseButton) {
        pauseButton.classList.remove("is-hidden");
      }
    };

    const syncPlaybackButtons = () => {
      if (video.paused || video.ended) {
        showPlay();
        return;
      }

      showPause();
    };

    const playVideo = () => {
      if (shouldPreloadForSafari()) {
        video.load();

        if (video.readyState >= 2) {
          playVideo();
          return;
        }

        video.addEventListener("canplay", () => {
          video.play().then(() => {
            syncPlaybackButtons();
          }).catch(() => {
            syncPlaybackButtons();
          });
        }, { once: true });
        return;
      }

      video
        .play()
        .then(() => {
          syncPlaybackButtons();
        })
        .catch(() => {
          syncPlaybackButtons();
        });
    };

    const togglePlayback = () => {
      if (video.paused || video.ended) {
        playVideo();
        return;
      }

      video.pause();
      syncPlaybackButtons();
    };

    const isInteractiveTarget = (target) => {
      if (!(target instanceof Element)) return false;

      if (
        playButton.contains(target) ||
        (pauseButton && pauseButton.contains(target))
      ) {
        return true;
      }

      return Boolean(
        target.closest(
          "a, button, input, select, textarea, label, summary, [role='button'], [tabindex]:not([tabindex='-1'])"
        )
      );
    };

    playButton.addEventListener("click", () => {
      playVideo();
    });

    if (pauseButton) {
      pauseButton.addEventListener("click", () => {
        video.pause();
        syncPlaybackButtons();
      });
    }

    if (shouldPreloadForSafari()) {
      video.load();
    }

    video.addEventListener("play", () => {
      syncPlaybackButtons();
    });

    video.addEventListener("playing", () => {
      syncPlaybackButtons();
    });

    video.addEventListener("pause", () => {
      syncPlaybackButtons();
    });

    video.addEventListener("ended", () => {
      syncPlaybackButtons();
    });

    if (mediaSurface) {
      mediaSurface.addEventListener("click", (event) => {
        if (isInteractiveTarget(event.target)) return;
        togglePlayback();
      });
    }

    if (contentSurface) {
      contentSurface.addEventListener("click", (event) => {
        if (isInteractiveTarget(event.target)) return;
        togglePlayback();
      });
    }

    syncPlaybackButtons();
  };

  const initSection = (section) => {
    if (section?.classList?.contains("media-banner-section")) {
      section.classList.toggle("is-safari", isSafariBrowser());
    }
    initAnimation(section);
    initVideoControls(section);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
